export default __webpack_public_path__ + "static/media/沙漏.8cb97ff1.svg";